module.exports = __webpack_public_path__ + "assets/images/topo_pattern-d10e81d1d183daef23d3826ab12cef82.svg";